import { render, staticRenderFns } from "./ChecklistsForm.vue?vue&type=template&id=05bdbb28"
import script from "./ChecklistsForm.vue?vue&type=script&lang=js"
export * from "./ChecklistsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports